export default __webpack_public_path__ + "static/media/ab-test-light.c6ed9ff7.svg";